import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';

const CampaignSelection = ({ initialCampaign, campaignOptions }) => {
  const initialScope = initialCampaign ? 'Campaign' : 'Product';
  const [scope, setScope] = useState(initialScope)
  const [campaign, setCampaign] = useState(initialCampaign);

  useEffect(() => {
    if (scope === 'Campaign') {
      $('#campaign-data').show();
    } else {
      $('#campaign-data').hide();
    }
  }, [scope]);

  const handleChange = (option) => {
    setScope(option.value);
  };

  const handleCampaign = (option) => {
    setCampaign(option);
  };

  return (
    <Fragment>
      <div style={ { width: '100%' } }>
        <SingleSelect
          handleChange={handleChange}
          options={[{ label: 'Campaign', value: 'Campaign' }, { label: 'Product', value: 'Product' }]}
          selectedValue={{ label: scope, value: scope }}
          placeholderText="Select Affect of Trigger"
        />
      </div>

      <br />

      {scope === 'Campaign' && (
        <div style={ { width: '100%' } }>
          <input name="scheduled_job[campaign]"
                 value={campaign && campaign.value}
                 hidden />
          <SingleSelect
            handleChange={handleCampaign}
            options={campaignOptions}
            selectedValue={campaign}
            placeholderText="Select Campaign"
          />
        </div>
      )}
    </Fragment>
  )
}

export default CampaignSelection;
